var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 33,
    viewBox: "0 0 46 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dark",
    d: "M7.69993e-06 2.6564C-0.00348842 1.19034 1.18401 0 2.65008 0H43.2846C44.7458 0 45.9312 1.18263 45.9347 2.64376L46 30.0279C46.0035 31.494 44.816 32.6843 43.3499 32.6843H2.71538C1.25425 32.6843 0.0687951 31.5017 0.0653107 30.0406L7.69993e-06 2.6564Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "light",
    d: "M2.64372 2.65008H43.2783V30.0342H2.64372V2.65008Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9291 12.5392C28.9291 15.7354 26.338 18.3265 23.1418 18.3265C19.9455 18.3265 17.3545 15.7354 17.3545 12.5392C17.3545 9.34293 19.9455 6.75186 23.1418 6.75186C26.338 6.75186 28.9291 9.34293 28.9291 12.5392Z",
    fill: "#DFEBFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "light",
    d: "M25.9399 11.9272C26.411 12.1992 26.411 12.8792 25.9399 13.1512L22.2727 15.2685C21.8015 15.5405 21.2126 15.2005 21.2126 14.6565L21.2126 10.4219C21.2126 9.87789 21.8015 9.53788 22.2727 9.80989L25.9399 11.9272Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "dark",
    d: "M9.64044 24.0327C9.64044 23.5449 10.0359 23.1494 10.5238 23.1494H36.7291C37.2169 23.1494 37.6124 23.5449 37.6124 24.0327V24.1951C37.6124 24.683 37.2169 25.0785 36.7291 25.0785H10.5238C10.0359 25.0785 9.64044 24.683 9.64044 24.1951V24.0327Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64044 24.0327C9.64044 23.5449 10.0359 23.1494 10.5238 23.1494H29.9772C30.4651 23.1494 30.8606 23.5449 30.8606 24.0327V24.1951C30.8606 24.683 30.4651 25.0785 29.9772 25.0785H10.5238C10.0359 25.0785 9.64044 24.683 9.64044 24.1951V24.0327Z",
    fill: "#DFEBFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedia);
export default __webpack_public_path__ + "static/media/iconMedia.4fd991dd60223fa2cfb9de9af47a12ff.svg";
export { ForwardRef as ReactComponent };